export const SET_FETCHING_BUSINESS_FORM_DATA_REQUEST_STATUS = 'SET_FETCHING_BUSINESS_FORM_DATA_REQUEST_STATUS'